import get from 'lodash/get';
import React from 'react';
import Schema from '../../Schema/Schema';
import { MOVIES } from '../../../constants/moviesConst';
import { getPaytmUrl } from '../../../services/urlCreator';

const EventSchema = (props: {
	movieData: any;
	cinemaData: any;
	entity: any;
	startDate: string;
}) => {
	const { movieData, cinemaData, entity, startDate } = props;
	return (
		<React.Fragment>
			{entity == MOVIES ? (
				<Schema
					schema={{
						'@context': 'http://schema.org/',
						'@type': 'Event',
						name: get(movieData, 'label'),
						url: getPaytmUrl(`/movies${get(cinemaData, 'entityUrl')}`),
						startDate,
						location: {
							'@type': 'Place',
							name: get(cinemaData, 'entityName', ''),
							address: {
								streetAddress: get(cinemaData, 'data.address', ''),
							},
						},
					}}
				/>
			) : (
				<Schema
					schema={{
						'@context': 'http://schema.org/',
						'@type': 'Event',
						name: get(movieData, 'entityName', ''),
						url: getPaytmUrl(`/movies${get(movieData, 'entityUrl')}`),
						startDate,
						location: {
							'@type': 'Place',
							name: get(cinemaData, 'label', ''),
							address: { streetAddress: get(cinemaData, 'address', '') },
						},
					}}
				/>
			)}
		</React.Fragment>
	);
};

export default EventSchema;
